export default (color="black",weight=2)=>`data:image/svg+xml;base64,${btoa(`
<svg fill="${color}" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 31.841 31.842" xml:space="preserve">
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
        <g>
            <g>
                <path
                    d="M21.06,15.747V3.201h-2.457L19.175,0h-7.382l0.43,3.201H9.637v12.532c-2.581,2.06-6.882,6.935-6.882,10.751v0.406 c0,4.951,4.244,4.951,7.341,4.951l1.041-0.001l10.609,0.001c1.891,0,3.561-0.048,4.878-0.636c1.634-0.729,2.462-2.181,2.462-4.315 v-0.406C29.087,23.186,26.125,19.2,21.06,15.747z M26.793,26.893c0,1.521-0.529,1.967-1.103,2.225 c-0.904,0.402-2.379,0.436-3.943,0.436H11.138H10.1c-4.155,0-5.05-0.472-5.05-2.66v-0.408c0-2.793,3.855-7.42,6.401-9.254 l0.481-0.344V5.496h0.6l0.155,1.147h5.302l0.205-1.147h0.57v11.477l0.521,0.34c4.556,3.012,7.507,6.611,7.507,9.172V26.893z">
                </path>
                <path
                    d="M17.925,18.111h-5.342c0,0-7.253,5.219-5.536,8.845c0,0,0.644,0.769,2.636,0.735c1.566-0.024,13.967,0.029,13.967,0.029 s2.506,0.006,1.528-1.992C24.632,24.613,22.292,19.832,17.925,18.111z">
                </path>
                <circle cx="16.379" cy="14.701" r="0.895"></circle>
                <circle cx="13.846" cy="10.872" r="0.716"></circle>
                <circle cx="15.708" cy="8.295" r="0.644"></circle>
            </g>
        </g>
    </g>
</svg>
`)}`;